import { makeAutoObservable } from 'mobx';

export type ParamValues = Record<string, any>;

export type PipelineContext = {
  tags: string[];
  equipmentTypes: string[];
  excludeExerciseIds: string[];
  paramValues: ParamValues;
  executeUntilStageId?: string;
  debug?: boolean;
  copy(params?: Partial<PipelineContext>): PipelineContext;
  merge(other: PipelineContext): PipelineContext;
};

export function createPipelineContext(json?: Partial<PipelineContext>): PipelineContext {
  return makeAutoObservable({
    tags: json?.tags || [],
    equipmentTypes: json?.equipmentTypes || [],
    excludeExerciseIds: json?.excludeExerciseIds ?? [],
    executeUntilStageId: json?.executeUntilStageId,
    paramValues: json?.paramValues || {},
    debug: json?.debug,

    copy(params?: Partial<PipelineContext>): PipelineContext {
      return createPipelineContext({ ...this, ...params });
    },

    merge(other: PipelineContext): PipelineContext {
      return createPipelineContext({
        tags: this.tags.concat(other.tags),
        equipmentTypes: this.equipmentTypes.concat(other.equipmentTypes),
        paramValues: { ...this.paramValues, ...other.paramValues },
        excludeExerciseIds: this.excludeExerciseIds.concat(other.excludeExerciseIds),
      });
    },
  });
}
